const GTM_LAYER_NAME = "gtmDataLayer";
const GTM_ID = "GTM-TZJSHLJ";

export class GoogleTagManager {

    private readonly script: HTMLScriptElement;

    constructor(
        doc: Document,
        private readonly win: Window,
        private readonly layerName = GTM_LAYER_NAME,
        id = GTM_ID
    ) {
        let scriptTag = "script";
        win[layerName] = win[layerName] || [];
        win[layerName].push({
            "gtm.start": new Date().getTime(),
            event: "gtm.js"
        });
        let f = doc.getElementsByTagName(scriptTag)[0];
        this.script = doc.createElement(scriptTag) as HTMLScriptElement;
        let dl = layerName !== "dataLayer" ? "&l=" + layerName : "";
        this.script.async = true;
        this.script.src = `https://www.googletagmanager.com/gtm.js?id=${ id }${ dl }`;

        if (f.parentNode) {
            f.parentNode.insertBefore(this.script, f);
            return;
        }
        doc.head.appendChild(this.script);
    }

    setDimensions (win: Window, dimensions: ITypedHash<string | Date | number>) {
        win[GTM_LAYER_NAME].push({
            event: "setUserParameters",
            ...dimensions
        });
    }

    destroy() {
        if (this.script) {
            this.script.parentNode?.removeChild(this.script);
        }
        this.win[this.layerName].length = 0;
    }
}